(ns re-frame.interop
  (:require [goog.async.nextTick]
            [goog.events :as events]
            [signaali.reactive :as sr]))

(defn on-load
  [listener]
  (try
    (events/listen js/self "load" listener)
    (catch :default _)))

(def next-tick goog.async.nextTick)

(def empty-queue #queue [])

(def after-render next-tick) ;; WON'T FIX

;; Make sure the Google Closure compiler sees this as a boolean constant,
;; otherwise Dead Code Elimination won't happen in `:advanced` builds.
;; Type hints have been liberally sprinkled.
;; https://developers.google.com/closure/compiler/docs/js-for-compiler
(def ^boolean debug-enabled? "@define {boolean}" ^boolean goog/DEBUG)

(defn ratom [x]
  (sr/create-state x {:propagation-filter-fn not=}))

(defn ratom? [x]
  ;; ^:js suppresses externs inference warnings by forcing the compiler to
  ;; generate proper externs. Although not strictly required as
  ;; reagent.ratom/IReactiveAtom is not JS interop it appears to be harmless.
  ;; See https://shadow-cljs.github.io/docs/UsersGuide.html#infer-externs
  (satisfies? sr/IReactiveNode ^js x))

(defn deref? [x]
  (satisfies? IDeref x))

(defn make-reaction [f]
  (sr/create-memo f {:propagation-filter-fn not=}))

(defn add-on-dispose! [a-ratom f]
  (sr/add-on-dispose-callback a-ratom f))

(defn dispose! [a-ratom]
  (sr/dispose a-ratom))

(defn set-timeout! [f ms]
  (js/setTimeout f ms))

(defn now []
  (if (and
       (exists? js/performance)
       (exists? js/performance.now))
    (js/performance.now)
    (js/Date.now)))

(defn reagent-id
  "Produces an id for reactive Reagent values
  e.g. reactions, ratoms, cursors."
  [reactive-val]
  ;; ^:js suppresses externs inference warnings by forcing the compiler to
  ;; generate proper externs. Although not strictly required as
  ;; reagent.ratom/IReactiveAtom is not JS interop it appears to be harmless.
  ;; See https://shadow-cljs.github.io/docs/UsersGuide.html#infer-externs
  (when (implements? sr/IReactiveNode ^js reactive-val)
    (str (condp instance? reactive-val
           sr/ReactiveNode "rn"
           "other")
         (hash reactive-val))))

(defn reactive?
  []
  (some? (sr/get-current-observer)))
